import React from 'react';
import Carousel from '../../Basepage/parts/Carousel';

import buttonPortofrei from '../../Basepage/parts/images/button-portofrei.svg';
import buttonPaket from '../../Basepage/parts/images/button-paket.svg';
import buttonleseprobe from '../../Basepage/parts/images/button-leseprobe-lila.svg';

import closeImage from '../../Basepage/parts/images/icon-filter-x.svg';

interface ImageContainerProp {
  hasProduct: boolean;
  isNewProduct: boolean;
  domainPrefix: string;
  isShipingFree: boolean;
  isPackageSend: boolean;
  hasMedia: boolean;
  hasLeseprobe: boolean;
  imagesSmall: string[];
  images: string[];
}

interface ImageContainerState {
  isPopupOpen: boolean;
  poopUpTopMargin: number;
  poopUpImageHeight: number;
}

export default class ImageContainer extends React.Component<
  ImageContainerProp,
  ImageContainerState
> {
  lastCarouselClick: number | null;
  popupCarousel: React.RefObject<Carousel>;

  constructor(props: ImageContainerProp) {
    super(props);
    this.state = {
      isPopupOpen: false,
      poopUpTopMargin: 0,
      poopUpImageHeight: 500,
    };

    this.lastCarouselClick = null;
    this.popupCarousel = React.createRef<Carousel>();
  }

  openPreview(currentIndex: number) {
    if (this.popupCarousel?.current != null) {
      this.popupCarousel.current.setNewItemIndex(currentIndex);
    } else {
      setTimeout(() => {
        this.openPreview(currentIndex);
      }, 100);
    }
    if (!this.state.isPopupOpen) {
      let popupHeight = this.state.poopUpImageHeight;
      let margin = (window.innerHeight - popupHeight) / 2;
      this.setState({ isPopupOpen: true, poopUpTopMargin: margin });
    }
  }

  render() {
    let productImages = [];
    let productImagesSmall = [];
    if (this.props.hasProduct) {
      productImages = JSON.parse(JSON.stringify(this.props.images));
      productImagesSmall = this.props.imagesSmall;
    }
    if (productImagesSmall.length == 0) {
      productImagesSmall.push('moluna_kein_bild.jpg');
    }

    return (
      <div id="p-left">
        <div id="info-buttons">
          {this.props.isNewProduct && (
            <img
              src={this.props.domainPrefix + '/images/layout/button-neu.svg'}
              alt="Neu"
            ></img>
          )}
          {/*{this.props.isShipingFree && (
            <a
              href={
                this.props.domainPrefix + '/index.php?main_page=shippinginfo'
              }
              target="_blank"
              rel="noopener"
              title="Portofrei - Alle Artikel, die mit diesem Paket Hinweis gekennzeichnet sind, versenden wir ohne weiteren Aufpreis für Sie als Paket."
            >
              <img
                src={buttonPortofrei}
                alt="reine Buchbestellungen ab 5 Euro senden wir Ihnen Portofrei zu"
              ></img>
            </a>
          )}
          {this.props.isPackageSend && (
            <a
              href={
                this.props.domainPrefix + '/index.php?main_page=page&id=125'
              }
              target="_blank"
              rel="noopener"
              title="Paket - Artikel mit diesem Symbol versenden wir für Sie ohne weiteren Aufpreis als Paket."
            >
              <img
                src={buttonPaket}
                alt="Diesen Artikel senden wir Ihnen ohne weiteren Aufpreis als PAKET"
              ></img>
            </a>
          )}*/}
          {this.props.hasMedia == false && <img src={buttonleseprobe}></img>}
        </div>
        <Carousel
          height={this.props.height + 'px'}
          showMultiple={false}
          showDots={this.props.showDots}
          clickHandle={(item, items, index) => {
            this.openPreview(index);

            /* 
            if (item.tagName == "IMG") {
              let parent = item.parentElement;
              parent.setAttribute("href", parent.getAttribute("data-href"));
              parent.setAttribute("rel", parent.getAttribute("data-rel"));
              $(parent).colorbox({
                opacity: 0.6,
                speed: 400,
                initialWidth: 250,
                initialHeight: 250,
                overlayClose: true,
                loop: true,
                current: "{current} of {total}"
              });
              parent.click();
              setTimeout(() => {
                //remove Handle
                parent.className = "";
                parent.removeAttribute("href");
                parent.removeAttribute("rel");
              }, 500); 
            }*/
          }}
        >
          {productImagesSmall.map((item, index) => {
            return (
              <img
                key={'imageCarousel' + index}
                src={'https://media.moluna.de/images/bilder/' + item}
                alt={this.props.title}
                style={{ cursor: 'pointer' }}
              ></img>
            );
          })}
        </Carousel>
        {this.state.isPopupOpen ? (
          <div
            className="overlay"
            onClick={(e) => {
              this.popupClick();
            }}
          >
            <img
              src={closeImage}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                width: '40px',
                background: 'white',
                cursor: 'pointer',
              }}
            />
            <div
              className="overlay_context"
              style={{ marginTop: this.state.poopUpTopMargin + 'px' }}
            >
              <Carousel
                key="popup"
                height={this.state.poopUpImageHeight + 'px'}
                showMultiple={false}
                showDots={false}
                disableDrag={false}
                clickGuiNotify={() => this.popupCarouselClick()}
                newItemNotify={(index) => this.resizeFrame(index)}
                ref={this.popupCarousel}
              >
                {productImages.map((item, index) => {
                  return (
                    <img
                      key={'imageCarousel_popup' + index}
                      src={'https://media.moluna.de/images/bilder/' + item}
                      alt={this.props.title}
                    ></img>
                  );
                })}
              </Carousel>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
  resizeFrame(index: number): void {
    if (
      this.popupCarousel.current != null &&
      this.popupCarousel.current.itemContainerRefsArray.length > index &&
      this.popupCarousel.current.itemContainerRefsArray[index].children !=
        undefined &&
      this.popupCarousel.current.itemContainerRefsArray[index].children.length >
        0
    ) {
      let imageHeight =
        this.popupCarousel.current.itemContainerRefsArray[index].children[0]
          .naturalHeight;
      let maxSize = window.innerHeight * 0.8;
      if (imageHeight > maxSize) {
        imageHeight = maxSize;
      }

      let margin = (window.innerHeight - imageHeight) / 2;
      this.setState({
        isPopupOpen: true,
        poopUpTopMargin: margin,
        poopUpImageHeight: imageHeight,
      });
    } else {
      setTimeout(() => this.resizeFrame(index), 100);
    }
  }
  popupCarouselClick() {
    this.lastCarouselClick = Date.now();
  }
  popupClick() {
    let now = Date.now();
    let closePopup = true;
    if (this.lastCarouselClick != null) {
      let diff = now - this.lastCarouselClick;
      if (diff < 1000) {
        closePopup = false;
      }
    }
    if (closePopup) this.setState({ isPopupOpen: false });
  }
}
